import { FC } from 'react';
import { useTaskDashboardCountsQuery } from '@/modules/common/queries/tasks.ts';
import { AnimatedNumbersSet } from 'ui';

const CommonStatistic: FC = () => {
  const { data: countsData, isLoading: isLoadingCounts } = useTaskDashboardCountsQuery();

  const todoTotal = countsData?.todo_count || 0;
  const overdueTotal = countsData?.due_count || 0;
  const upcomingTotal = countsData?.upcoming_count || 0;
  const historyTotal = countsData?.completed_count || 0;

  return (
    <AnimatedNumbersSet
      loading={isLoadingCounts}
      numbers={[
        { title: 'To do ', number: todoTotal },
        { title: 'Overdue', number: overdueTotal || 0 },
        { title: 'Upcoming', number: upcomingTotal || 0 },
        { title: 'Completed', number: historyTotal || 0 },
      ]}
    />
  );
};

export default CommonStatistic;
